/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, { Component, Fragment } from "react";
import NavBar from "../components/global/NavBar";
import {Grid, CircularProgress, Typography, Tooltip, Paper} from "@material-ui/core";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Redirect } from "react-router-dom";
import {
    uploadDataset,
    buildSomeClassifier,
    buildSomeModels,
    getSomeClassifications, getSomeLocalExplanation, getSomeExplanations, getDataset, getConfig
} from "../components/global/API";
import CustomizedSnackbars from "../components/global/CustomizedSnackbars";
import AlgorithmCard from "../components/algorithm/AlgorithmCard";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Checkbox from "@material-ui/core/Checkbox";
import StepperSimple from "../components/global/StepperSimple";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import galicia from "../components/images/galicia.png";
import usc from "../components/images/usc.png";
import campusVida from "../components/images/campusvida.png";
import ue from "../components/images/ue.png";
import xunta from "../components/images/xunta.png";
import IconButton from "@material-ui/core/IconButton";
import HelpIcon from "@material-ui/icons/Help";
import xacobeo from "../components/images/xacobeo-color-original.jpg";
import citius_horizontal from "../components/images/citius_horizontal.png";

const TextOnlyTooltip = withStyles({
    tooltip: {
        color: "white",
        backgroundColor: "#ff9800",
        fontSize: "1em"
    }
})(Tooltip);

const styles = theme => ({
    root: {
        marginTop: 40,
        justifyContent: "center",
        justifyItems: "center",
        display: "-webkit-flex",
        webkitFlexWrap: "wrap",
        flexWrap: "wrap",

    },
    container: {
        marginTop: 70,
        justifyContent: "center",
        justifyItems: "center",
        display: "grid",
        webkitFlexWrap: "wrap",
        flexWrap: "wrap",
        textAlign:"center",
    },
    button: {
        width:"150px",
        marginTop: "30px",
        backgroundColor: "#4caf50",
        fontSize: "20px",
        color: "white",
        "&:hover": {
            backgroundColor: "#357a38"
        }
    },
    buttonCancel: {
        width:"150px",
        marginTop: "30px",
        backgroundColor: "#ff5f52",
        fontSize: "20px",
        color: "white",
        "&:hover": {
            backgroundColor: "#C62828"
        }
    },
    progress: {
        margin: "auto",
        marginTop: 40,
        marginBottom: 30
    },
    footer:{
        boxShadow: "0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
        display:"inline-table",
        justifyContent:"space-evenly",
        position:"fixed",
        bottom:0,
        height:100,
        left:0,
        width:"100%",
        backgroundColor:"white",
    },
    centerFotter:{
        display:"flex",
        justifyContent:"space-evenly",
    },
    leftLogos: {
        height: 36,
        marginTop: 20,
        marginBottom: 20
    },
    rightLogos: {
        height: 60,
        marginTop: 20,
        marginBottom: 20
    },
    loader: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        justifyItems: "center"
    },
    switchClassDisabled:{
        color:"primary",
    },
    table: {
        minWidth: 650,
    },
    head: {
        backgroundColor: "#4caf50",
        fontcolor: "white",
    },
});

class Algorithms extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: this.props.classifierExists ? this.props.dataset : "example",
            nameError: false,
            error: false,
            loading: false,
            file: undefined,
            j48: true,
            randomTree: true,
            repTree: true,
            furia: true,
            htFuzzy: true,
            randomForest: true,
            j48Configuration: false,
            randomTreeConfiguration: false,
            repTreeConfiguration: false,
            furiaConfiguration: false,
            htFuzzyConfiguration: false,
            randomForestConfiguration: false,
            checkedA: true,
            checkedB: false,
            algorithms: ["J48", "RandomTree", "REPTree", "FuzzyHoeffdingDecisionTree", "FURIA", "RandomForest"],
            FURIAparams: {
                tnorm: 0,
                batchSize: 100,
                checkErrorRate: true,
                doNotCheckCapabilities: false,
                folds: 3,
                minNo: 2,
                numDecimalPlaces: 2,
                optimizations: 2,
                seed: 1,
                uncovAction: 0
            },
            HTparams: {
                fuzzyCardinality: true,
                fuzzySets: 3,
                propertyLabels: "L1,L2,L3",
                centroids: "0.5",
                gracePeriod: 25.0,
                hoeffdingTieThreshold: 2.5,
                leafPredictionStrategy: 0,
                minimumFractionOfWeightInfoGain: 0.01,
                naiveBayesPredictionThreshold: 0.0,
                numDecimalPlaces: 2,
                printLeafModels: false,
                admitRepetitions: false,
                splitConfidence: 1.0e-7,
                splitCriterion: 1
            },
            J48params: {
                binarySplits: false,
                collapseTree: true,
                doNotMakeSplit: false,
                confidenceFactor: 0.25,
                minNumObj: 2,
                numFolds: 3,
                reduceError: false,
                seed: 1,
                subtreeRaising: true,
                unpruned: false,
                useLaplace: false,
                useMDL: true
            },
            Randomparams: {
                valueK: 0,
                minNumObj: 1,
                minVarianceProp: 0.001,
                seed: 1,
                maxDepth: 0,
                numFolds: 0,
                allowUnclassified: false,
                breakTies: false,
                numDecimalPlaces: 2
            },
            REPparams: {
                noCheckCapabilities: false,
                initialCount: 0,
                maxDepth: -1,
                minNumObj: 2,
                minVarianceProp: 0.001,
                noPruning: false,
                numDecimal: 2,
                numFolds: 3,
                seed: 1,
                spreadInitialCount: false
            },
            RandomForestParams: {
                bagSizePercent: 100,
                batchSize: 100,
                breakTiesRandomly: false,
                calcOutOfBag: false,
                completeAttributeImportance: false,
                debug: false,
                doNotCheckCapabilities: false,
                maxDepth: 0,
                numDecimalPlaces: 2,
                numExecutionSlots: 1,
                numFeatures: 0,
                numIterations: 100,
                outputOutOfBagComplexityStatistics: false,
                printClassifiers: false,
                seed: 1,
                storeOutOfBagPredictions: false,
            },
            clickButton: false,
            checkedLocal: true,
            checkedGlobal: true,
            compareTable:false,
            helpTool:true,
        };
        this.changeFile = this.changeFile.bind(this);
        this.handleAlgorithmClick = this.handleAlgorithmClick.bind(this);
        this.selectOneAlgorithm = this.selectOneAlgorithm.bind(this);
        this.changeAlgorithm = this.changeAlgorithm.bind(this);
        this.cancelBuild = this.cancelBuild.bind(this);
        this.handleChangeSwitchA = this.handleChangeSwitchA.bind(this);
        this.handleChangeSwitchB = this.handleChangeSwitchB.bind(this);
        this.handleChangeLocal = this.handleChangeLocal.bind(this);
        this.handleChangeGlobal = this.handleChangeGlobal.bind(this);
        this.compareExplanations = this.compareExplanations.bind(this);
        this.getConfig = this.getConfig.bind(this);
        this.getLocalExplanations = this.getLocalExplanations.bind(this);
        this.getSomeGlobalExplanation = this.getSomeGlobalExplanation.bind(this);
        this.getDataset = this.getDataset.bind(this);
        this.goBackSelectAlgorithms = this.goBackSelectAlgorithms.bind(this);
        this.goBackGeneralInformation = this.goBackGeneralInformation.bind(this);
        this.clickHelpIcon = this.clickHelpIcon.bind(this);
    }

    componentDidMount() {
        const timer = setTimeout(() => {
            this.setState({
                helpTool:false,
            })
        }, 5000);
        return () => clearTimeout(timer);
    }
    componentDidUpdate(prevProps,prevState) {
        if(prevState.helpTool===false && this.state.helpTool===true){
            const timer = setTimeout(() => {
                this.setState({
                    helpTool:false,
                })
            }, 5000);
            return () => clearTimeout(timer);
        }
    }

    async goBackSelectAlgorithms() {
        this.setState({compareTable: false});
    }
    async goBackGeneralInformation(){
        this.setState({goBackGeneralInformation: true});
    }
    async buildClassifierPromise(){
        console.log(this.props.datasetNewBeginner)
        var response = await uploadDataset(
            this.props.datasetNewBeginner,
            this.props.file,
            this.props.token
        );
        if (response.error) {
            if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                    loading: false,
                    redirect: true
                });
            } else {
                this.setState({
                    loading: false,
                    error: true,
                    message: response.data
                });
            }
        } else {
            this.setState(
                {
                    dataset: response.data
                },
                async () => {
                    response = await buildSomeClassifier(
                        this.props.datasetNewBeginner,
                        true,true,true,
                        true,true,true,
                        this.state.J48params,
                        this.state.Randomparams,
                        this.state.REPparams,
                        this.state.FURIAparams,
                        this.state.HTparams,
                        this.state.RandomForestParams,
                        this.props.token
                    )
                    if (response.error) {
                        if (response.status === 401) {
                            this.props.handleGlobalMessage(
                                "error",
                                this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                            );
                            this.props.closeSession();
                            this.setState({
                                loading: false,
                                redirect: true
                            });
                        } else {
                            //await deleteDataset(this.state.name, this.props.token);
                            this.setState({
                                    loading: false,
                                    error: true,
                                    message: response.data
                                },
                            );
                        }
                    } else {
                        this.setState({
                                classifier: response.data,
                            },
                            async () => {
                                response = await buildSomeModels(
                                    this.props.datasetNewBeginner,
                                    true,true,true,
                                    true,true,true,
                                    this.state.J48params,
                                    this.state.Randomparams,
                                    this.state.REPparams,
                                    this.state.FURIAparams,
                                    this.state.HTparams,
                                    this.state.RandomForestParams,
                                    this.props.token
                                );
                                if (response.error) {
                                    if (response.status === 401) {
                                        this.props.handleGlobalMessage(
                                            "error",
                                            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                        );
                                        this.props.closeSession();
                                        this.setState({
                                            loading: false,
                                            redirect: true
                                        });
                                    } else {
                                        //await deleteDataset(this.state.name, this.props.token);
                                        this.setState({
                                            loading: false,
                                            error: true,
                                            message: response.data
                                        });
                                    }
                                } else {
                                    this.setState(
                                        {
                                            classifier: response.data,
                                        },
                                        async () => {
                                            this.getConfig(this.props.datasetNewBeginner)
                                            this.getDataset(this.props.datasetNewBeginner)
                                            this.getSomeGlobalExplanation(this.props.datasetNewBeginner)
                                            this.getLocalExplanations(this.props.datasetNewBeginner)
                                        }
                                    );
                                }
                            });
                    }
                }
            );
        }
    }
    async compareExplanations() {
        if(this.state.checkedGlobal === false && this.state.checkedLocal=== false){
            this.props.handleGlobalMessage(
                "error",
                this.props.language.labels[this.props.language.id].errorMessageLeastExplanation
                //"Please select at least one type of explanation"
            );
        }else if(!this.state.j48 && !this.state.repTree && !this.state.randomTree && !this.state.furia && !this.state.htFuzzy && !this.state.randomForest){
            this.props.handleGlobalMessage(
                "error",
                this.props.language.labels[this.props.language.id].errorMessageLeatsAlgorithm
               // "Please select at least one algorithm"
            );
        }else {
            if (this.props.dataset === "new") {
                Promise.all([this.getConfig(this.props.datasetNewBeginner), this.getSomeGlobalExplanation(this.props.datasetNewBeginner), this.getLocalExplanations(this.props.datasetNewBeginner), this.getDataset(this.props.datasetNewBeginner)]).then(() => {
                    this.setState({compareTable: true});
                });
            } else {
                if (this.state.checkedLocal && this.state.checkedGlobal) {
                    Promise.all([this.getConfig(this.props.dataset), this.getSomeGlobalExplanation(this.props.dataset), this.getLocalExplanations(this.props.dataset), this.getDataset(this.props.dataset)]).then(() => {
                        this.setState({compareTable: true});
                    });
                } else if (this.state.checkedLocal) {
                    Promise.all([this.getConfig(this.props.dataset), this.getSomeGlobalExplanation(this.props.dataset), this.getLocalExplanations(this.props.dataset), this.getDataset(this.props.dataset)]).then(() => {
                        this.setState({compareTable: true});
                    });
                } else if (this.state.checkedGlobal) {
                    Promise.all([this.getConfig(this.props.dataset), this.getSomeGlobalExplanation(this.props.dataset), this.getLocalExplanations(this.props.dataset), this.getDataset(this.props.dataset)]).then(() => {
                        this.setState({compareTable: true});
                    });
                } else {
                }
            }
        }
    }
    async getConfig(name) {
        var response = await getConfig(
            name,
            this.props.language.id,
            this.props.token
        );

        if (response.error) {
            if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                    redirect: true
                });
            } else {
                this.setState({
                    error: true,
                    message: response.data
                });
            }
        } else {
            var maximo=0;
            for(var i=0;i<response.data.attributes.length;i++){
                if(response.data.attributes[i].name.length>maximo){
                    maximo=response.data.attributes[i].name.length;
                }
            }
            console.log(response)
            this.setState(
                {
                    maximo: maximo,
                    config: response.data,
                    isDefault:
                        response.data.dataset === "beer" ||
                        response.data.dataset === "glass" ||
                        response.data.dataset === "wine" ||
                        response.data.dataset === "iris" ||
                        response.data.dataset === "flavia" ||
                        response.data.dataset === "vehicle" ||
                        response.data.dataset === "ACB" ||
                        response.data.dataset === "PIMA" ||
                        response.data.dataset === "OULAD" ||
                        response.data.dataset === "bank"
                    ,
                    percentage: 5
                }
            );
        }
    }
    async getSomeGlobalExplanation(name){
        var response = await getSomeExplanations(
            name,
            this.props.language.id,
            this.props.token
        );
        if (response.error) {
            if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                    loading: false,
                    redirect: true
                });
            } else {
                this.setState({
                    loading: false,
                    error: true,
                    message: response.data
                });
            }
        } else {
            this.setState({
                globalExplanationJ48: response.data.j48.clauses,
                percentageJ48:response.data.j48.precision.toFixed(2),
                globalExplanationREPTree: response.data.repTree.clauses,
                percentageREPTree:response.data.repTree.precision.toFixed(2),
                globalExplanationRandomTree: response.data.randomTree.clauses,
                percentageRandomTree:response.data.randomTree.precision.toFixed(2),
                globalExplanationFURIA: response.data.furia.clauses,
                percentageFURIA:response.data.furia.precision.toFixed(2),
                globalExplanationHoeffdingTreeFuzzy: response.data.htFuzzy.clauses,
                percentageHoeffdingTreeFuzzy:response.data.htFuzzy.precision.toFixed(2),
                globalExplanationRandomForest: response.data.randomForest.clauses,
                percentageRandomForest:response.data.randomForest.precision.toFixed(2),
            })
        }
    }
    async getDataset(name) {
        var response = await getDataset(name, this.props.token);

        if (response.error) {
            if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                    redirect: true
                });
            }
            this.setState({
                error: true,
                message: response.data
            });
        } else {
            const labelsInstances = response.data.lines.map((instance, index) => ({
                value: index,
                label: "Instance " + (index + 1)
            }));

            this.setState({
                instances: response.data.lines,
                labelsInstances,
                selectedInstance: labelsInstances[0],
                instanceIndex: 0,
                instance: {
                    attributes: response.data.lines[0].attributes,
                    solution: response.data.lines[0].solution
                }
            });
        }
    }


    handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        this.setState({
            error: false
        });
    };

    changeFile(event) {
        this.setState({
            file: event.target.files[0]
        });
    }


    cancelBuild() {
        if (this.props.classifierExists) {
            console.log('Cancel function' + this.props.lastAlgorithm)
            this.props.changeAlgorithm(this.props.lastAlgorithm, this.state.name).then(
                this.props.handleDataset(this.state.name)
            )
        } else {
            this.setState({
                redirectToHome: true,
            })
        }
    }

    async getLocalExplanations(name) {
        var values = this.props.values;
        console.log(values)
            var response = await getSomeClassifications(
                name,
                this.props.language.id,
                0,
                values,
                this.props.token
            );

            if (response.error) {
                if (response.status === 401) {
                    this.props.handleGlobalMessage(
                        "error",
                        this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                    );
                    this.props.closeSession();
                    this.setState({
                        redirect: true
                    });
                } else {
                    this.setState({
                        error: true,
                        message: response.data
                    });
                }
            } else {
                console.log(response.data)
                this.setState({
                        classificationsJ48: response.data.classificationsJ48,
                        classificationsREPTree: response.data.classificationsREPTree,
                        classificationsRandomTree: response.data.classificationsRandomTree,
                        classificationsFURIA: response.data.classificationsFURIA,
                        classificationsHoeffdingTreeFuzzy: response.data.classificationsHoeffdingTreeFuzzy,
                        rulesHoeffdingTreeFuzzy:response.data.rulesHoeffdingTreeFuzzy,
                        localExplanationRandomForest: response.data.classificationsRadomForest,
                    },
                    async () => {
                        response = await getSomeLocalExplanation(
                            name,
                            this.state.classificationsJ48,
                            this.state.classificationsREPTree,
                            this.state.classificationsRandomTree,
                            this.state.classificationsFURIA,
                            this.state.rulesHoeffdingTreeFuzzy,
                            this.props.language.id,
                            this.props.token
                        );
                        if (response.error) {
                            if (response.status === 401) {
                                this.props.handleGlobalMessage(
                                    "error",
                                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                );
                                this.props.closeSession();
                                this.setState({
                                    redirect: true
                                });
                            } else {
                                this.setState({
                                    error: true,
                                    message: response.data
                                });
                            }
                        } else {
                            this.setState({
                                localExplanationJ48: response.data.j48.clauses,
                                localExplanationREPTree: response.data.repTree.clauses,
                                localExplanationRandomTree: response.data.randomTree.clauses,
                                localExplanationFURIA: response.data.furia.clauses,
                                localExplanationHoeffdingTreeFuzzy: response.data.htFuzzy.clauses,
                            });
                        }
                    })
            }
    }

    async changeAlgorithm() {
        console.log(this.state.j48)
        console.log(this.state.randomTree)
        console.log(this.state.repTree)
        console.log(this.state.furia)
        if(this.state.j48){

            return this.props.changeAlgorithmDataset("J48",this.state.name);

            }else{
                if(this.state.randomTree){
                    return this.props.changeAlgorithmDataset("RandomTree",this.state.name);
                }else{
                    if(this.state.repTree){
                        return this.props.changeAlgorithmDataset("REPTree",this.state.name);
                    }else{
                        if(this.state.furia){
                            return this.props.changeAlgorithmDataset("FURIA",this.state.name);
                        }else{
                            if(this.state.htFuzzy){
                                return this.props.changeAlgorithmDataset("FuzzyHoeffdingDecisionTree",this.state.name);
                            }else{
                                if(this.state.randomForest){
                                    return this.props.changeAlgorithmDataset("RandomForest",this.state.name);
                                }else{

                                }
                            }
                        }
                    }
                }
        }
        /*if (algorithm === "FURIA") {
            var response = await getRules(
                this.props.dataset,
                algorithm,
                this.props.language.id,
                this.props.token
            );
            if (!response.error) {
                this.setState({
                    redirect: true
                });
            }
        } else {
            response = await getTree(
                this.props.dataset,
                algorithm,
                this.props.language.id,
                this.props.token
            );
            console.log(response.error);
            if (!response.error) {
                this.setState({
                    redirect: true
                });
            }
        }*/
    }

    selectOneAlgorithm(algoritmo){
        console.log('Aqui cehgamos'+algoritmo)
        if(algoritmo === "J48"){
            this.setState({
                j48:true,
                randomTree:false,
                repTree:false,
                furia:false,
                htFuzzy:false,
                randomForest:false,
            })
        }else if(algoritmo === "RandomTree"){
            this.setState({
                j48:false,
                randomTree:true,
                repTree:false,
                furia:false,
                htFuzzy:false,
                randomForest:false,
            })
        }else if(algoritmo === "REPTree"){
            this.setState({
                j48:false,
                randomTree:false,
                repTree:true,
                furia:false,
                htFuzzy:false,
                randomForest:false,
            })
        }else if(algoritmo === "FURIA"){
            this.setState({
                j48:false,
                randomTree:false,
                repTree:false,
                furia:true,
                htFuzzy:false,
                randomForest:false,
            })
        }else if(algoritmo === "FuzzyHoeffdingDecisionTree"){
            this.setState({
                j48:false,
                randomTree:false,
                repTree:false,
                furia:false,
                htFuzzy:true,
                randomForest:false,
            })
        }else if(algoritmo === "RandomForest"){
            this.setState({
                j48:false,
                randomTree:false,
                repTree:false,
                furia:false,
                htFuzzy:false,
                randomForest:true,
            })
        }
    }
    handleChangeSwitchA= event => {
        if(this.state.checkedA === false && this.state.checkedB === true){
            this.setState({
                checkedA: true,
                checkedB: false,
                j48:true,
                repTree:true,
                randomTree:true,
                furia:true,
                htFuzzy:true,
                randomForest:true,
            })
        }else if(this.state.checkedA === false){
            this.setState({
                checkedA: true,
                j48:true,
                repTree:true,
                randomTree:true,
                furia:true,
                htFuzzy:true,
                randomForest:true,
            })
        }else{
            this.setState({
                checkedB: false,
            })
        }
    }
    handleChangeSwitchB= event => {
        if(this.state.checkedB === false && this.state.checkedA === true){
            this.setState({
                checkedB: true,
                checkedA: false,
                j48:false,
                repTree:false,
                randomTree:false,
                furia:false,
                htFuzzy:false,
                randomForest:false,
            })
        }else if(this.state.checkedB === false){
            this.setState({
                checkedB: true,
                j48:false,
                repTree:false,
                randomTree:false,
                furia:false,
                htFuzzy:false,
                randomForest:false,
            })
        }else{
            this.setState({
                checkedB: false,
            })
        }
    }
    handleChangeGlobal(){
        this.setState({
            checkedGlobal:!this.state.checkedGlobal,
        })
    }
    handleChangeLocal(){
        this.setState({
            checkedLocal:!this.state.checkedLocal,
        })
    }
    handleAlgorithmClick(algoritmo,checked){
        console.log(algoritmo+" "+checked);
        if(algoritmo === "J48" ){
            if(checked && this.state.randomTree && this.state.repTree
                && this.state.furia && this.state.htFuzzy && this.state.randomForest){
                this.setState({checkedA:true,j48:checked});
            }else{
                this.setState({checkedA:false,j48:checked});
            }
            if(!checked && !this.state.randomTree && !this.state.repTree
                && !this.state.furia && !this.state.htFuzzy && !this.state.randomForest){
                this.setState({checkedB:true,j48:checked});
            }else{
                this.setState({checkedB:false,j48:checked});
            }
        }else if(algoritmo === "RandomTree"){
            if(this.state.j48 && checked && this.state.repTree
                && this.state.furia && this.state.htFuzzy && this.state.randomForest){
                this.setState({checkedA:true,randomTree:checked});
            }else{
                this.setState({checkedA:false,randomTree:checked});
            }
            if(!checked && !this.state.j48 && !this.state.repTree
                && !this.state.furia && !this.state.htFuzzy && !this.state.randomForest){
                this.setState({checkedB:true,randomTree:checked});
            }else{
                this.setState({checkedB:false,randomTree:checked});
            }
        }else if(algoritmo === "REPTree"){
            if(this.state.j48 && checked && this.state.randomTree
                && this.state.furia && this.state.htFuzzy && this.state.randomForest){
                this.setState({checkedA:true,repTree:checked});
            }else{
                this.setState({checkedA:false,repTree:checked});
            }
            if(!checked && !this.state.j48 && !this.state.randomTree
                && !this.state.furia && !this.state.htFuzzy && !this.state.randomForest){
                this.setState({checkedB:true,repTree:checked});
            }else{
                this.setState({checkedB:false,repTree:checked});
            }
        }else if(algoritmo === "FURIA"){
            if(this.state.j48 && checked && this.state.randomTree
                && this.state.repTree && this.state.htFuzzy && this.state.randomForest){
                this.setState({checkedA:true,furia:checked});
            }else{
                this.setState({checkedA:false,furia:checked});
            }
            if(!checked && !this.state.j48 && !this.state.randomTree
                && !this.state.repTree && !this.state.htFuzzy && !this.state.randomForest){
                this.setState({checkedB:true,furia:checked});
            }else{
                this.setState({checkedB:false,furia:checked});
            }
        }else if(algoritmo === "FuzzyHoeffdingDecisionTree"){
            if(this.state.j48 && checked && this.state.randomTree
                && this.state.furia && this.state.furia && this.state.randomForest){
                this.setState({checkedA:true,htFuzzy:checked});
            }else{
                this.setState({checkedA:false,htFuzzy:checked});
            }
            if(!checked && !this.state.j48 && !this.state.randomTree
                && !this.state.furia && !this.state.furia && !this.state.randomForest){
                this.setState({checkedB:true,htFuzzy:checked});
            }else{
                this.setState({checkedB:false,htFuzzy:checked});
            }
        }else if(algoritmo === "RandomForest"){
            if(this.state.j48 && checked && this.state.randomTree
                && this.state.furia && this.state.furia && this.state.htFuzzy){
                this.setState({checkedA:true,randomForest:checked});
            }else{
                this.setState({checkedA:false,randomForest:checked});
            }
            if(!checked && !this.state.j48 && !this.state.randomTree
                && !this.state.furia && !this.state.furia && !this.state.htFuzzy){
                this.setState({checkedB:true,randomForest:checked});
            }else{
                this.setState({checkedB:false,randomForest:checked});
            }
        }

    }
    handleChangeName = event => {
        var regex = /^[A-Za-z0-9]{4,20}$/;
        console.log(event.target)
        this.setState({
            nameError: event.target.value.match(regex) ? false : true,
            name: event.target.value
        });
    };
    clickHelpIcon(){
        this.setState({
            helpTool:!this.state.helpTool
        })
    }
    render() {
        const { classes } = this.props;

        return this.state.loading ? (
            <Fragment>
            <NavBar
                language={this.props.language}
                handleLanguageChange={this.props.handleLanguageChange}
            />
            <div className={classes.loader}>
                <CircularProgress className={classes.progress} size={100} />
                <Typography variant="h3" align="center">
                    {this.props.language.labels[this.props.language.id].loading}
                </Typography>
            </div>
            </Fragment>
        ) : (
            <Fragment>
                <NavBar
                    language={this.props.language}
                    handleLanguageChange={this.props.handleLanguageChange}
                />
                {this.state.compareTable === false &&
                <Grid container style={{marginBottom:110,marginTop: 80}} justify="center">
                    {this.props.mode === "beginner" &&
                    <StepperSimple
                        language={this.props.language}
                        initialValue={2}
                        compareExplanations={this.compareExplanations}
                        goBackGeneralInformation = {this.goBackGeneralInformation}
                    />
                    }
                    <Grid xs={12} className={classes.container}>
                        <Fragment>
                            <Typography variant="h4">
                                {this.props.language.labels[this.props.language.id].algorithmExplanation}
                            </Typography>
                            <FormGroup row>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            disabled={this.state.checkedA}
                                            disableRipple={true}
                                            classes={{disabled: classes.switchClassDisabled}}
                                            checked={this.state.checkedA}
                                            color="primary"
                                            onChange={this.handleChangeSwitchA}
                                            name="checkedA"
                                            inputProps={{'aria-label': 'primary checkbox'}}
                                        />}
                                    label={this.props.language.labels[this.props.language.id].selectAll}
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            disabled={this.state.checkedB}
                                            checked={this.state.checkedB}
                                            onChange={this.handleChangeSwitchB}
                                            color="primary"
                                            name="checkedB"
                                            inputProps={{'aria-label': 'primary checkbox'}}
                                        />
                                    }
                                    label={this.props.language.labels[this.props.language.id].deselectAll}
                                />
                            </FormGroup>
                            <TextOnlyTooltip title={this.props.language.labels[this.props.language.id].help9} open={this.state.helpTool}>
                            <FormGroup row>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.checkedLocal}
                                            onChange={this.handleChangeLocal}
                                            name="checkedB"
                                            color="primary"
                                        />
                                    }
                                    label={this.props.language.labels[this.props.language.id].localExplanation}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.checkedGlobal}
                                            onChange={this.handleChangeGlobal}
                                            name="checkedGlobal"
                                            color="primary"
                                        />
                                    }
                                    label={this.props.language.labels[this.props.language.id].globalExplanation}
                                />
                            </FormGroup>
                            </TextOnlyTooltip>
                            <IconButton onClick={this.clickHelpIcon}>
                                <HelpIcon/>
                            </IconButton>
                        </Fragment>
                    </Grid>
                    <Grid item xs={12} className={classes.root}>

                        <Fragment>
                            {this.state.algorithms.map(algorithm => {
                                var checked = false;
                                if (algorithm === "J48" && this.state.j48) {
                                    checked = true;
                                } else if (algorithm === "RandomTree" && this.state.randomTree) {
                                    checked = true;
                                } else if (algorithm === "REPTree" && this.state.repTree) {
                                    checked = true;
                                } else if (algorithm === "FURIA" && this.state.furia) {
                                    checked = true;
                                } else if (algorithm === "FuzzyHoeffdingDecisionTree" && this.state.htFuzzy) {
                                    checked = true;
                                } else if (algorithm === "RandomForest" && this.state.randomForest) {
                                    checked = true;
                                }
                                console.log('checked' + algorithm + " " + checked)
                                return (
                                    <AlgorithmCard
                                        key={algorithm}
                                        language={this.props.language}
                                        handleAlgorithmClick={this.handleAlgorithmClick}
                                        algorithm={algorithm}
                                        algorithmChecked={this.props.algorithmChecked}
                                        selectOneAlgorithm={this.selectOneAlgorithm}
                                        checked={checked}
                                        showConfig={false}
                                    />
                                );
                            })}
                        </Fragment>

                    </Grid>
                </Grid>
                }
                {this.state.compareTable &&
                <Grid container style={{marginBottom:100,marginTop: 80}} justify="center">
                    {this.props.mode === "beginner" &&
                    <StepperSimple
                        language={this.props.language}
                        initialValue={2}
                        compareExplanations={this.compareExplanations}
                        goBackSelectAlgorithms = {this.goBackSelectAlgorithms}
                        goBackGeneralInformation = {this.goBackGeneralInformation}
                        lastStep={true}
                    />
                    }
                    <Grid xs={12} className={classes.container}>
                        {this.state.checkedLocal &&
                            <>
                        <Paper style={{minWidth:650,width:"80%"}}>
                            <Table className={classes.table} aria-label="simple table">
                                <TableHead className={classes.head}>
                                    <TableRow>
                                        <TableCell style={{color: "white"}}>{this.props.language.labels[this.props.language.id].algorithm}</TableCell>
                                        <TableCell style={{color: "white"}}>{this.props.language.labels[this.props.language.id].localExplanation}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.j48 && this.state.localExplanationJ48 &&
                                    <TableRow>
                                        <TableCell>J48</TableCell>
                                        <TableCell>
                                            {this.state.localExplanationJ48.map(item => {
                                                return item + " ";
                                            })}
                                        </TableCell>
                                    </TableRow>
                                    }
                                    {this.state.repTree && this.state.localExplanationREPTree &&
                                    <TableRow>
                                        <TableCell>REPTree</TableCell>
                                        <TableCell>
                                            {this.state.localExplanationREPTree.map(item => {
                                                return item + " ";
                                            })}
                                        </TableCell>
                                    </TableRow>
                                    }
                                    {this.state.randomTree && this.state.localExplanationRandomTree &&
                                    <TableRow>
                                        <TableCell>RandomTree</TableCell>
                                        <TableCell>
                                            {this.state.localExplanationRandomTree.map(item => {
                                                return item + " ";
                                            })}
                                        </TableCell>
                                    </TableRow>
                                    }
                                    {this.state.furia && this.state.localExplanationFURIA &&
                                    <TableRow>
                                        <TableCell>FURIA</TableCell>
                                        <TableCell>
                                            {this.state.localExplanationFURIA.map(item => {
                                                return item + " ";
                                            })}
                                        </TableCell>
                                    </TableRow>
                                    }
                                    {this.state.htFuzzy && this.state.localExplanationHoeffdingTreeFuzzy &&
                                    <TableRow>
                                        <TableCell>FuzzyHoeffdingDecisionTree</TableCell>
                                        <TableCell>
                                            {this.state.localExplanationHoeffdingTreeFuzzy.map(item => {
                                                return item + " ";
                                            })}
                                        </TableCell>
                                    </TableRow>
                                    }
                                    {this.state.randomForest &&
                                    <TableRow>
                                        <TableCell>RandomForest</TableCell>
                                        <TableCell>
                                            {this.state.localExplanationRandomForest}
                                        </TableCell>
                                    </TableRow>
                                    }
                                </TableBody>
                            </Table>

                        </Paper>
                        </>
                        }
                        {this.state.checkedGlobal &&
                            <Fragment>
                        <Paper style={{minWidth:650,width:"80%",marginTop:100}}>
                            <Table className={classes.table} aria-label="simple table">
                                <TableHead className={classes.head}>
                                    <TableRow>
                                        <TableCell style={{color: "white"}}>{this.props.language.labels[this.props.language.id].algorithm}</TableCell>
                                        <TableCell style={{color: "white"}}>{this.props.language.labels[this.props.language.id].globalExplanation}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.j48 &&
                                    <TableRow>
                                        <TableCell>J48</TableCell>
                                        <TableCell>
                                            {this.state.globalExplanationJ48.map(item => {
                                                return item + " ";
                                            })}
                                        </TableCell>
                                    </TableRow>
                                    }
                                    {this.state.repTree &&
                                    <TableRow>
                                        <TableCell>REPTree</TableCell>
                                        <TableCell>
                                            {this.state.globalExplanationREPTree.map(item => {
                                                return item + " ";
                                            })}
                                        </TableCell>
                                    </TableRow>
                                    }
                                    {this.state.randomTree &&
                                    <TableRow>
                                        <TableCell>RandomTree</TableCell>
                                        <TableCell>
                                            {this.state.globalExplanationRandomTree.map(item => {
                                                return item + " ";
                                            })}
                                        </TableCell>
                                    </TableRow>
                                    }
                                    {this.state.furia &&
                                    <TableRow>
                                        <TableCell>FURIA</TableCell>
                                        <TableCell>
                                            {this.state.globalExplanationFURIA.map(item => {
                                                return item + " ";
                                            })}
                                        </TableCell>
                                    </TableRow>
                                    }
                                    {this.state.htFuzzy &&
                                    <TableRow>
                                        <TableCell>FuzzyHoeffdingDecisionTree</TableCell>
                                        <TableCell>
                                            {this.state.globalExplanationHoeffdingTreeFuzzy.map(item => {
                                                return item + " ";
                                            })}
                                        </TableCell>
                                    </TableRow>
                                    }
                                    {this.state.randomForest &&
                                    <TableRow>
                                        <TableCell>RandomForest</TableCell>
                                        <TableCell>
                                            {this.state.globalExplanationRandomForest.map(item => {
                                                return item + " ";
                                            })}
                                        </TableCell>
                                    </TableRow>
                                    }
                                </TableBody>
                            </Table>

                        </Paper>
                        </Fragment>
                        }
                    </Grid>
                </Grid>
                }
                <footer className={classes.footer}>
                    <Grid container direction="row" alignItems="center" justify={"center"}>
                        <Grid  className={classes.centerFotter} item xs={12} md={8} lg={8} >
                            <img
                                src={galicia}
                                alt="logo turístico galicia"
                                className={classes.leftLogos}
                            />
                            <img
                                src={xacobeo}
                                alt="logo xacobeo 2021"
                                className={classes.leftLogos}
                            />
                            <img src={citius_horizontal} alt="logo citius" className={classes.leftLogos} />
                            <img src={usc} alt="logo usc" className={classes.leftLogos} />
                            <img
                                src={campusVida}
                                alt="logo campus vida"
                                className={classes.leftLogos}
                            />
                        </Grid>
                        <Grid className={classes.centerFotter}  item xs={12} md={4} lg={4} >
                            <img
                                src={ue}
                                alt="logo unión europea"
                                className={classes.rightLogos}
                            />
                            <img
                                src={xunta}
                                alt="logo xunta de galicia"
                                className={classes.rightLogos}
                            />
                        </Grid>
                    </Grid>
                    <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "center"}}>
                        {this.props.language.labels[this.props.language.id].fondoEuropeo}
                    </Typography>
                </footer>
                <CustomizedSnackbars
                    openFail={this.state.error}
                    handleClose={this.handleClose}
                    message={this.state.message}
                />
                {!this.props.token ? <Redirect to="/" /> : ""}
                {this.state.redirectToHome && <Redirect to="/" /> }
                {this.state.ready && this.props.handleDataset(this.state.name)}
                {this.state.goBackGeneralInformation && <Redirect to={"/classifiersAll"}/>}
            </Fragment>

        );
    }
}
Algorithms.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Algorithms);
